// extracted by mini-css-extract-plugin
module.exports = {"priceUnitFull":"price-unit-full_priceUnitFull__4BR_L","priceUnitFullChecked":"price-unit-full_priceUnitFullChecked__u3Q_I"};